import { ProfileCircle } from "iconsax-react";
import { FC } from "react";
import { Link } from "react-router-dom";
import { Label } from "reactstrap";
import { Href, MyActive, SignOut } from "../../../constants";
import { AccountData } from "../../../data/layout/Header";
import { routes } from "../../../routers/routes";
import { HeaderType } from "../../../types/Layout";
import LanguageSection from "./LanguageSelector";

const AccountMenu: FC<HeaderType> = ({ part }) => {
  return (
    <div className="icon-side">
      <div className="login-flex onhover-dropdown">
        <a href={Href} className="login-icon">
          <ProfileCircle className="iconsax" />
          <span>Account</span>
          <i className="ri-arrow-down-wide-line" />
        </a>
        <ul className="login-list onhover-list">
          <li className="active-item">
            <span>{MyActive}</span>
          </li>
          {AccountData.map((item, index) => (
            <li key={index} className="active-item">
              <Link to={routes.Pages.Other.UserDashboard}>{item}</Link>
              {item === "Searches" && <Label>New</Label>}
            </li>
          ))}
          <li className="active-item">
            <Link to={routes.Pages.Other.Login1} className="btn-solid">
              {SignOut}
            </Link>
          </li>
        </ul>
      </div>
      {!part?.includes("property") && <LanguageSection />}
    </div>
  );
};

export default AccountMenu;
